var _style, _polygon, _path, _polygon2, _path2, _polygon3, _path3, _g, _script;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHertz(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 612 296.49",
    style: {
      enableBackground: "new 0 0 612 296.49"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFD100;}\n\t.st1{fill:#9D9D9C;}\n")), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "467.86,205.89 114.2,205.89 118.26,186.77 471.94,186.76 "
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M383.07,153.89c-3.16-3.4-1.27-10.17,0.35-17.81l5.52-25.95h22.69l4.11-19.32h-22.71l4.03-19.28h-21.39l-14.02,66.32  c-2.11,9.91-2.9,17.66,1.39,26.01c4,7.76,17.66,15.17,34.95,10.49l3.82-17.93C390.09,157.87,385.38,156.35,383.07,153.89z"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "201.91,71.53 191.7,119.43 154.16,119.43 164.34,71.53 142.75,71.53 120.92,174.35 142.49,174.35 150.03,138.72   187.59,138.72 180.03,174.35 201.43,174.35 223.28,71.53 "
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M325.17,98.07c-7.49,6.25-11.74,14.44-14.5,27.36l-10.39,48.91h21.41l8.63-40.56c2.04-9.49,3.6-15.42,7.16-19.07  c4.9-5.01,12.01-5.29,20.54-4.58l4.12-19.32C347.09,86.99,333.95,90.74,325.17,98.07z"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "492.28,90.81 425.45,90.81 421.36,110.13 460.13,110.13 411.64,155.77 407.7,174.35 474.52,174.35 478.64,155.04   439.65,155.04 488.38,109.19 "
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M266.74,89.28c-7.23,0-17.12,2.24-26.84,9.87c-21.91,17.19-32.79,76.72,14.26,76.72c12.2,0,25.77-3.85,35.18-10.96  l-8.51-14.38c-7.12,5.48-42.99,17.39-39.21-11.68h56.07c0.02-0.06,7.15-23.3-3.13-37.36C285.81,89.49,269.68,89.28,266.74,89.28z   M280.66,121.15h-34.32c1.21-4.62,8.5-15.99,22.03-14.75C282.93,107.75,280.66,121.15,280.66,121.15z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Registered_Trademark_2_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M488.99,163.62c-0.01,0-0.02,0-0.06,0c-3.33,0.02-6.52,2.71-7.22,5.97c-0.09,0.42-0.13,0.84-0.13,1.25v0.01   c0.01,2.64,1.91,4.65,4.8,4.66c0.01,0,0.02-0.01,0.02-0.01c3.33-0.02,6.51-2.73,7.22-5.98c0.09-0.42,0.13-0.84,0.13-1.23   C493.77,165.64,491.85,163.63,488.99,163.62z M492.81,169.37c-0.59,2.84-3.54,5.34-6.41,5.32h-0.01c-2.51-0.05-3.94-1.6-3.99-3.85   c0-0.35,0.04-0.72,0.12-1.09c0.57-2.83,3.5-5.31,6.37-5.32c2.56,0.05,3.99,1.59,4.04,3.86   C492.94,168.62,492.89,168.99,492.81,169.37z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M488.51,166.72h-2.54l-1.21,5.69h1.26l0.39-1.84h1l0.82,1.84h1.48l-0.97-2.04c0.79-0.26,1.41-0.85,1.61-1.78   C490.59,167.41,489.87,166.72,488.51,166.72z M489.05,168.67c-0.11,0.49-0.53,0.83-1.16,0.83h-1.25l0.35-1.67h1.22   C488.85,167.83,489.17,168.11,489.05,168.67z"
  }))), _script || (_script = /*#__PURE__*/React.createElement("script", {
    xmlns: "",
    type: "text/javascript",
    src: "chrome-extension://hejbmebodbijjdhflfknehhcgaklhano/../window/testing-library.js"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHertz);
export default __webpack_public_path__ + "static/media/hertz.770986cb0d1095eafb2882e295cc6946.svg";
export { ForwardRef as ReactComponent };